import React, { Component } from 'react'
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';
import img from './../images/carousel_img/4.jpg'
import img2 from './../images/carousel_img/6.jpg'
import img3 from './../images/carousel_img/1.jpg'
export default class Home extends Component {

  render() {
    document.title = "Home";
    return (<>
      <div className="">
      <Carousel>
      <div>
          <img src={img} aria-hidden alt=''  width="100%" height="100%"/>
          <p className="legend">It is the supreme art of the teacher to awaken joy in creative expression and knowledge</p>
      </div>
      <div>
      <img src={img2} aria-hidden alt='' width="100%" height="100%"/>
          <p className="legend">You have to grow from the inside out. None can teach you, none can make you spiritual. There is no other teacher but your own soul.</p>
      </div>
      <div>
          <img src={img3} aria-hidden alt='' width="100%" height="100%"/>
          <p className="legend">The task of the modern educator is not to cut down jungles, but to irrigate deserts.
          </p>
      </div>
  </Carousel>
    </div>
    
    <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 mb-md-0 ">
            <h2>Contact Us</h2>
            <address>
              <p><iframe title="This is a unique title 2" className="col-lg-12 col-md-12 col-sm-12 p-0" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3469.7282953570743!2d72.23897511458223!3d29.582507847201864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393c66abe032da15%3A0x8a19a558b256d0fc!2sStreet%20To%20People%20Bazaar%2C%20Khairpur%20Tamewali%2C%20Bahawalpur%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1648625609460!5m2!1sen!2s" style={{border: 0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" /></p>
              <strong className="text-uppercase"><i className="fa fa-map-marker cl-atlantis fa-1x" /> Ideal Training Academy</strong>   <p>
                Near Madni Masjid Mohallah Mehmoodi Wala Pepel Bazar Khairpur Tamewali, 
                Bahawalpur, Punjab, 
                Pakistan 
              </p>
              <strong><i className="fa fa-phone cl-atlantis fa-1x" /> +92-306-7728788</strong>             
            </address>
          </div>
          <div className="col-lg-6 col-12">
            <h2>About Us</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas, voluptates, soluta velit nostrum ut iste exercitationem vitae ipsum repellendus laudantium ab possimus nemo odio cumque illum nulla laborum blanditiis unde.</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas, voluptates, soluta velit nostrum ut iste exercitationem vitae ipsum repellendus laudantium ab possimus nemo odio cumque illum nulla laborum blanditiis unde.</p>
            <ul className="list-inline list-social-icons mb-0">
              <li className="list-inline-item"> <a href="/"> <span className="fa-stack fa-lg"> <i className="fa fa-circle fa-stack-2x" /> <i className="fa fa-facebook fa-stack-1x fa-inverse" /> </span> </a> </li>
              <li className="list-inline-item"> <a href="/"> <span className="fa-stack fa-lg"> <i className="fa fa-circle fa-stack-2x" /> <i className="fa fa-twitter fa-stack-1x fa-inverse" /> </span> </a> </li>
              <li className="list-inline-item"> <a href="/"> <span className="fa-stack fa-lg"> <i className="fa fa-circle fa-stack-2x" /> <i className="fa fa-linkedin fa-stack-1x fa-inverse" /> </span> </a> </li>
              <li className="list-inline-item"> <a href="/"> <span className="fa-stack fa-lg"> <i className="fa fa-circle fa-stack-2x" /> <i className="fa fa-github fa-stack-1x fa-inverse" /> </span> </a> </li>
            </ul>
          </div>
        </div>
      </div>
      
      </>
    )
  }
}
